export const translations = {
	'System configuration': {
		en: 'System configuration',
		no: 'Systemkonfigurasjon',
	},
	'Override': {
		en: 'Override',
		no: 'Overstyring',
	},
	'Show excluded': {
		en: 'Show excluded',
		no: 'Vis ekskluderte',
	},
	'Disks': {
		en: 'Disks',
		no: 'Disker',
	},
	'Checkpoints': {
		en: 'Checkpoints',
		no: 'Sjekkpunkter',
	},
	'Critical breach value': {
		en: 'Critical breach value',
		no: 'Kritisk brudd verdi',
	},
	'Event message': {
		en: 'Event message',
		no: 'Hendelsemelding',
	},
	'Monitor type': {
		en: 'Monitor type',
		no: 'Monitortype',
	},
	'Warning breach value': {
		en: 'Warning breach value',
		no: 'Advarsel brudd verdi',
	},
	'New profile': {
		en: 'New profile',
		no: 'Ny profile',
	},
	'Edit disk filter': {
		en: 'Edit disk filter',
		no: 'Endre disk filter',
	},
	'Metric only': {
		en: 'Metric only',
		no: 'Bare metrikk',
	},
	'Metric and health': {
		en: 'Metric and health',
		no: 'Metrikk og helse',
	},
	'Create profile': {
		en: 'Create profile',
		no: 'Opprett profile',
	},
	'Disk filter': {
		en: 'Disk filter',
		no: 'Diskfilter',
	},
	'Disk filter tooltip': {},
	'Test results': {
		en: 'Test result',
		no: 'Testresultat',
	},
	'Matches filter': {
		en: 'Match filter',
		no: 'Matcher filter',
	},
	'Matches in other profiles': {
		en: 'Matches in other profiles',
		no: 'Matcher i andre profiler',
	},
	'Save and close': {
		en: 'Update and close',
		no: 'Oppdater og lukk',
	},
	'Override is only for Assetgroups': {
		en: 'Override is only for assetgroups',
		no: 'Overstyring er kun for ressursgrupper',
	},
	'Click + to create': {
		en: 'No checkpoint. Click + to create',
		no: 'Ingen sjekkpunkt. Klikk + for å opprette',
	},
	'No Override profiles created. Click Asset menu to get started.': {
		en: 'No override profile. Click asset menu to get started',
		no: 'Ingen overstyringsprofil er opprettet. Klikk i ressurs meny for å komme igang.',
	},
	'No override checkpoints. Click + to get started.': {
		en: 'No override checkpoint. Click + to create',
		no: 'Ingen overstyringssjekkpunt.Klikk + for å opprette.',
	},
	'There are no available checkpoints to add': {
		en: 'There are no more checkpoint to add',
		no: 'Det er ikke flere sjekkpunkt',
	},
	'Override profile': {
		en: 'Override profile',
		no: 'Overstyr profil',
	},
	'No Checkpoints. Click + to create.': {
		en: 'No checkpoint. Click + to create',
		no: 'Ingen sjekkpunkt. Klikk + for å opprette',
	},
	'Memory profile': {
		en: 'Memory profile',
		no: 'Minneprofil',
	},
	'Add checkpoint': {
		en: 'Add checkpoint',
		no: 'Legg til sjekkpunkt',
	},
	'Are you sure you want to delete the profile?': {
		en: 'Are you sure you want to delete the profile?',
		no: 'Vil du slette profilen?',
	},
	'Overrides': {
		en: 'Overrides',
		no: 'Overstyringer',
	},
	'Asset name': {
		en: 'Asset name',
		no: 'Ressursnavn',
	},
	'New profile name': {
		en: 'New profile name',
		no: 'Nytt profilnavn',
	},
	'Remove asset from override profile': {
		no: 'Fjern ressurs fra overstyringsprofil',
	},
	'Are you sure you want to delete the override profile?': {
		en: 'Are you sure you want to delete the override profile?',
		no: 'Vil du slette overstyringsprofil',
	},
	'Create override': {
		en: 'Create override',
		no: 'Lag overstyring',
	},
	'Are you sure you want to remove the assets from overrides? If the asset is the last in the profile the whole profile will be deleted':
		{
			en: 'Are you sure you want to remove the assets from override profile? If there are no asset in override profile it will be deleted',
			no: 'Er du sikker på at du vil fjerne ressursene fra overstyringen? Hvis profilen ikke har ressurser blir den fjernet',
		},
	'Are you sure you want to remove the asset from overrides? If the asset is the last in the profile the whole profile will be deleted':
		{
			en: 'Are you sure you want to remove the asset from override profile? If there are no asset in override profile it will be deleted',
			no: 'Er du sikker på at du vil fjerne ressursen fra overstyringen? Hvis profilen ikke har ressurser blir den fjernet',
		},
	'CPU': {
		en: 'CPU',
		no: 'CPU',
	},
	'CPU profile': {
		en: 'CPU profile',
		no: 'CPU profil',
	},
	'CPU Advanced': {
		en: 'CPU advanced',
		no: 'CPU avansert',
	},
	'CPU Breach analysis': {
		en: 'CPU breach analysis',
		no: 'CPU brudd analyse',
	},
	'CPU breach analysis - Detailed event message': {
		en: 'Show # of processes that consume most CPU when threshold is breached',
		no: 'Viser # prosessene med høyest CPU forbruk når terskelverdien overskrides',
	},
	'Processes count': {
		en: 'Processes count',
		no: 'Prosessantall',
	},
	'Exclude disk': {
		en: 'Exclude disk',
		no: 'Eksluder disk',
	},
	'Enable list mem processes': {
		en: 'Enable list mem processes',
		no: 'Aktiver minneprosess',
	},
	'Use HyperV max memory': {
		en: 'Use HyperV max memory',
		no: 'Bruk HyperV maks minne',
	},
	'Warning breach value can not be {0} critical breach value': {
		en: 'Warning breach value can not be {0} than critical breach value',
		no: 'Advarselsverdien kan ikke være {0} enn kritisk verdi',
	},
	'NTP server': {
		en: 'NTP server',
		no: 'NTP server',
	},
	'Reboot': {
		en: 'Reboot',
		no: 'Restart',
	},
	'Time profile': {
		en: 'Time profile',
		no: 'Tidsprofil',
	},
	'Reboot profile': {
		en: 'Reboot profile',
		no: 'Restartprofil',
	},
	'Memory breach analysis': {
		en: 'Memory breach analysis',
		no: 'Minnebrudd analyse',
	},
	'Memory breach analysis - tooltip': {
		en: 'Show # processes that consume most memory when a threshold is breached',
		no: 'Viser # prosesser med høyest minneforbruk når terskelverdien overskrides',
	},
	'NTP server - tooltip': {
		en: 'Enter the hostname or IP address of the NTP server to use as the time source for monitor tests. The server must be reachable from this system and respond to NTP queries on UDP port 123.',
		no: 'Skriv inn vertsnavn eller IP-adresse til NTP-serveren som skal brukes som tidskilde for monitortester. Serveren må være tilgjengelig fra dette systemet og svare på NTP-forespørsler på UDP-port 123.',
	},
	'Memory advanced': {
		en: 'Memory advanced',
		no: 'Minne avansert',
	},
	'Profile is not active in this override profile': {
		en: 'This profile is not active in override profile',
		no: 'Denne profilen er ikke aktiv i oversytringsprofilen',
	},
	'Not available for this checkpoint': {
		en: 'Not available for this checkpoint',
		no: 'Ikke tilgjengelig for dette sjekkpunktet',
	},
	'Shared disk': {
		en: 'Shared disk',
		no: 'Delt disk',
	},
	'Custom profile': {
		en: 'Custom profile',
		no: 'Tilpasset profil',
	},
	'Error loading the monitor': {
		en: 'Error loading the monitor',
		no: 'Feil ved lasting av monitor',
	},
	'Are you sure you want to remove the disk?': {
		en: 'Are you sure you want to remove the disk?',
		no: 'Vil du fjerne disken?',
	},
	'Are you sure you want to remove the disks?': {
		en: 'Are you sure you want to remove the disks?',
		no: 'Vil du fjerne diskene?',
	},
	'Display name': {
		en: 'Display name',
		no: 'Visningsnavn',
	},
	'Shared disks': {
		en: 'Shared disks',
		no: 'Delt disker',
	},
	'Add disk': {
		en: 'Add disk',
		no: 'Legg til disk',
	},
	'Remove disk': {
		en: 'Remove disk',
		no: 'Fjern disk',
	},
	'Edit disk': {
		en: 'Edit disk',
		no: 'Rediger disk',
	},
	'Path': {
		en: 'Path',
		No: 'Filsti',
	},
	'New disk': {
		en: 'New disk',
		no: 'Ny disk',
	},
	'Shared disk information': {
		en: 'Shared disk information',
		no: 'Delt disk informasjon',
	},
	'Not found': {
		en: 'Not found',
		no: 'Ikke funnet',
	},
	'Exclude from these profiles': {
		en: 'Exclude from this profile',
		no: 'Eksluder fra denne profilen',
	},
	'Exclude from the current profile': {
		en: 'Exclude from current profile',
		no: 'Eksluder fra denne profilen',
	},
	'Connecting': {},
	'Connected successfully': {
		en: 'Connected successfully',
		no: 'Tilkoblingen var vellykket',
	},
	'No connection': {
		en: 'No connection',
		no: 'Ingen tilkobling',
	},
	'A successful connection is required': {
		en: 'A connection is required',
		no: 'En tilkobling kreves',
	},
	'Command execution': {
		en: 'Command execution',
		no: 'Kommandoutførelse',
	},
	'Command execution - tooltip': {
		en: 'Controls how the system handles data collection',
		no: 'Kontrollerer hvordan system monitoren håndterer datainnsamling',
	},
	'Average over': {
		en: 'Average over',
		no: 'Gjennomsnitt over',
	},
	'Command average over - tooltip': {
		en: 'Calculates the average over a set number of measurements (default 5). An alert is only triggered if both the current value and the average breach the threshold.',
		no: 'Beregner gjennomsnittet over et valgt antall målinger (standard 5). Varsel utløses kun dersom både verdien og gjennomsnittet overskrider grenseverdien.',
	},
	'Retries': {
		en: 'Retries',
		no: 'Forsøk',
	},
	'Command retries - tooltip': {
		en: 'Retries: Number of reconnection attempts on failure. (Default: 2 retries)',
		no: 'Gjentakelser: Antall nye forsøk ved feil. (Default: 2 forsøk)',
	},
	'Command timeout - tooltip': {
		en: 'Timeout: Maximum time per attempt. (Default: 60 seconds)',
		no: 'Tidsavbrudd: Maksimal tid per forsøk.  (Default: 60 sekund)',
	},
	'Sleep': {
		en: 'Sleep',
		no: 'Pause',
	},
	'Command sleep - tooltip': {
		en: 'Sleep: Delay between each retry attempt. (Default: 500 milliseconds)',
		no: 'Pause: Ventetid mellom hvert forsøk. (Default: 500 millisekund)',
	},
	'Timeout': {
		en: 'Timeout',
		no: 'Tidsavbrudd',
	},
	'Active profiles': {
		en: 'Active profiles',
		no: 'Aktive profiler',
	},
	'New override': {
		en: 'New override',
		no: 'Ny overstyring',
	},
	'Select profiles': {
		en: 'Select profiles',
		no: 'Velg profiler',
	},
	'No matches in the others profiles': {
		en: 'No matches in other profiles',
		no: 'Ingen treff i andre profiler',
	},
	'Disk is excluded from the profile': {
		en: 'Disk is excluded from the profile',
		no: 'Disk er eksludert fra profil',
	},
	'Disk filter required message': {
		en: 'You must create a valid disk filter before you can configure your profile',
		no: 'Du må opprette et gyldig diskfilter før du kan konfigurere profilen din',
	},
	'Required disk - tooltip': {
		en: 'Required disks must be present on all agents in the group. This setting overrides all disk filters',
		no: 'Påkrevde disker må finnes på alle agenter i ressursgruppen. Dette overstyrer eventuelle diskfiltre',
	},
	'Required disk': {
		en: 'Required disk',
		no: 'Påkrevd disk',
	},
	'Set required': {
		en: 'Set required',
		no: 'Sett påkrevd',
	},
	'Remove required': {
		en: 'Remove required',
		no: 'Fjern påkrevd',
	},
	'Override ({0})': {
		en: 'Override ({0})',
		no: 'Overstyring ({0})',
	},
	'Default disk filter is overridden': {
		en: 'Default disk filter is overridden',
		no: 'Standard disk filter er overstyrt',
	},
	'{0} (from default)': {
		en: '{0} (From default)',
		no: '{0} (Fra standard)',
	},
	'Disk monitoring': {
		en: 'Disk monitoring',
		no: 'Disk monitorering',
	},
	'Shared disk monitoring': {
		en: 'Shared disk monitoring',
		no: 'Delt disk monitorering',
	},
	'CPU monitoring': {
		en: 'CPU monitoring',
		no: 'CPU monitorering',
	},
	'Memory monitoring': {
		en: 'Memory monitoring',
		no: 'Minne monitorering',
	},
	'Time monitoring': {
		en: 'Time monitoring',
		no: 'Tid monitorering',
	},
	'Overview': {
		en: 'Overview',
		no: 'Oversikt',
	},
	'Some checkpoint values are not valid': {
		no: 'Noen sjekkpunktverdier er ugyldige',
	},
	'Select profile': {
		en: 'Select profile',
		no: 'Velg profil',
	},
};
